import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { getCardLogo } from 'reservations/payments/helpers/getCardLogo';
import { getReadableCardType } from 'reservations/payments/helpers/getReadableCardType';

type Props = {
  cardType: string;
  cardLast4: string;
  cardExpMonth?: number;
  cardExpYear?: number;
  isExpirationValid?: boolean;
};

export function CardInformation({
  cardType,
  cardLast4,
  cardExpMonth,
  cardExpYear,
  isExpirationValid = true
}: Props) {
  const CardLogo = getCardLogo(cardType);

  let expiration = null;

  if (cardExpMonth != null && cardExpYear != null) {
    const formattedExpMonth =
      cardExpMonth < 10 ? `0${cardExpMonth}` : cardExpMonth;
    const formattedExpYear = cardExpYear.toString().slice(-2);
    expiration = ` - Exp. ${formattedExpMonth}/${formattedExpYear}`;
  }

  return (
    <>
      <Box pr={1.0}>
        <CardLogo />
      </Box>
      <Box>
        <Typography
          sx={theme => ({
            color: isExpirationValid
              ? theme.typography.body1.color
              : theme.palette.error.main
          })}
        >
          {getReadableCardType(cardLast4)}
          {expiration}
        </Typography>
      </Box>
    </>
  );
}
